import { render, staticRenderFns } from "./viewCard.vue?vue&type=template&id=11195ea6"
import script from "./viewCard.vue?vue&type=script&lang=js"
export * from "./viewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports